
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {}
})
export default class EditPenIcon extends  Vue {
  @Prop({ type: Number, required: false, default: 11 }) readonly width!: number;
  @Prop({ type: Number, required: false, default: 10 }) readonly height!: number;
}
